import { isEmpty } from 'lodash';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTextBody1, MBTextBody1Bold } from '@shared/components/typography';
import { Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  channelName: string;
  query: string;
}

export function QuickCreateCard({ channelName, query }: Props) {
  return (
    <View paddingTop={2}>
      <View row centerVertically>
        <MBIconV2 name="plus" color={Colors.v2.purple} size={grid(4)} />
        <View flex paddingLeft={2}>
          <View row wrap paddingRight={1}>
            <MBTextBody1>{i18n('card.blocks.cardsInput.createNewCardLabelPrefix')}</MBTextBody1>
            {!isEmpty(query) && <MBTextBody1Bold>{query}</MBTextBody1Bold>}
            <MBTextBody1>
              {i18n('card.blocks.cardsInput.createNewCardLabelSuffix') + ' '}
            </MBTextBody1>
            <MBTextBody1Bold>{channelName}</MBTextBody1Bold>
          </View>
        </View>
      </View>
    </View>
  );
}
